<div class="team-page">

  <section class="team-hero">
    <div class="team-hero-inner">
      <p class="team-eyebrow">
        Our Team
      </p>

      <h1>
        The People
        <span>Behind the Brand</span>
      </h1>

      <p class="team-hero-sub">
        Every great franchise starts with great people.
        Meet the team behind McTemplate.
      </p>
    </div>
  </section>

  <section class="team-members">
    <div class="team-inner">

      @if (loading) {
        <div class="team-state">
          <p>Loading our team...</p>
        </div>
      }

      @else if (loadError) {
        <div class="team-state">
          <h2>Unable to load our team.</h2>
          <p>Please check back again soon.</p>
        </div>
      }

      @else if (staffMembers.length === 0) {
        <div class="team-state">
          <h2>Meet the team soon.</h2>
          <p>Team profiles are being added.</p>
        </div>
      }

      @else {
        @for (
          member of staffMembers;
          track member.id;
          let index = $index
        ) {
          <div
            class="member-card"
            [class.reverse]="index % 2 === 1"
          >

            <div class="member-image-wrap">
            <div
              class="member-photo-hover"
              [class.is-placeholder]="isPlaceholderImage(member.imageUrl)"
            >
              @if (member.imageUrl) {
                <img
                  [src]="member.imageUrl"
                  [alt]="member.name"
                  class="photo-default"
                />
              }
            </div>
            </div>

            <div class="member-info">
              <p class="member-role">
                {{ member.title }}
              </p>

              <h2>
                {{ member.name }}
              </h2>

              @if (member.bio) {
                <p class="member-bio">
                  {{ member.bio }}
                </p>
              }
            </div>

          </div>
        }
      }

    </div>
  </section>

</div>